import AUTH_CONFIG from "../config/auth.config";
import { AppConstants } from "../constants/app.constant";

document.addEventListener(AppConstants.CUSTOM_EVENTS.LOG_OUT_USER, () => {
    // localStorage.removeItem(AppConstants.SSO_AUTH_TOKEN_DETAIL);
    localStorage.clear();
    window.location.href = `${AUTH_CONFIG.SSO_BASE_PATH}/idp/startSLO.ping`;
  });